export default "__VITE_ASSET__CIBcN_o1__"